import { autoInjectable, singleton } from 'tsyringe';
import { ConfigUtilService } from '../config/config-util.service';
import { ApiException } from './api/exception';
import { EpJsConfig } from '../../models/config.model';
import { GeneratePlacementRequest } from './api/GeneratePlacementRequest';
import { GeneratePlacementResponse } from './api/GeneratePlacementResponse';

@autoInjectable()
@singleton()
export class EpAdServerClient {
  get config(): EpJsConfig{
    return this.configUtilService.getConfig();
  }

  defaultOptions: RequestInit = {
    headers: {
      'content-type': 'application/json'
    },
    mode: 'cors'
  };

  constructor(
    private configUtilService?: ConfigUtilService,
  ) {}

  async generatePlacements(placementRequest?: GeneratePlacementRequest){
    const options = {
      method: 'POST',
    };
    if(!!placementRequest) {
        placementRequest.brandId = this.config.apiKey;
    }
    const response = await this.makeRequest<GeneratePlacementRequest>('/generatePlacements', placementRequest, options);

    if (response.ok) {
      const body: GeneratePlacementResponse = await response.json();
      return body;
    }else{
      throw new ApiException<string>(response.status, `Unknown API Status Code!\nBody: "${response.body || ''}"`);
    }
  }

  makeRequest = <T>(path: string, data: Partial<T>, options: Partial<RequestInit>) => {
    const reqOptions: RequestInit = {
      ...this.defaultOptions,
      ...options,
      body: JSON.stringify(data),
    };
    const url = `${this.config.apiHost}${path}`;
    return fetch(url, reqOptions);
  }
}
